export const NO_ERROR_HANDLING = "X-No-Error-Handling"
export const NOT_AVAILABLE = "Not available"
export const NUMBER_LOCALES: { [key: string]: string } = {
  en: "en-CH",
  de: "de-AT",
}
